import React, { ReactElement } from "react";
import { Theme } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import Typography from "@material-ui/core/Typography";
import createStyles from "@material-ui/core/styles/createStyles";
import withStyles from "@material-ui/core/styles/withStyles";
import { Button } from "../inputs/Button";
import { Icon } from "../icons/Icon";

const styles = (theme: Theme) =>
  createStyles({
    buttonRow: {
      display: "flex",
      justifyContent: "center",
      marginBottom: theme.spacing(1),
      marginTop: theme.spacing(2),
      width: "100%"
    },
    filterContent: {
      display: "flex",
      flexFlow: "row wrap",
      justifyContent: "space-around",
      marginTop: theme.spacing(2),
      width: "350px"
    },
    filterIcon: {
      marginRight: theme.spacing(1),
      zIndex: 3
    },
    filterMenu: {
      padding: theme.spacing(2),
      position: "absolute",
      right: 0,
      top: "60px",
      overflow: "visible",
      zIndex: 1
    },
    submit: {
      marginRight: theme.spacing(2)
    }
  });

type State = {
  formOpen: boolean;
};

type Props = {
  classes?: any;
  filterFields?: ReactElement;
  onFilterReset?: () => void;
  onFilterSubmit: () => void;
};

class TableFilter extends React.Component<Props, State> {
  initialFilterState: any;
  constructor(props: Props) {
    super(props);
    this.state = {
      formOpen: false
    };
    this.onResetFilter = this.onResetFilter.bind(this);
    this.onSubmitFilter = this.onSubmitFilter.bind(this);
    this.onToggleForm = this.onToggleForm.bind(this);
  }

  onToggleForm() {
    this.setState(prevState => ({
      formOpen: !prevState.formOpen
    }));
  }

  onResetFilter() {
    this.props.onFilterReset && this.props.onFilterReset();
  }

  onSubmitFilter() {
    const { onFilterSubmit } = this.props;
    onFilterSubmit();
    this.onToggleForm();
  }

  renderForm() {
    const { classes, filterFields } = this.props;
    return (
      <Card className={classes.filterMenu}>
        <Typography variant="h5">Filter</Typography>
        <div className={classes.filterContent}>{filterFields}</div>
        <div className={classes.buttonRow}>
          <div>
            <Button
              id="submit"
              className={classes.submit}
              color="primary"
              onClick={this.onSubmitFilter}
            >
              Submit
            </Button>
            <Button id="reset" onClick={this.onResetFilter}>
              Reset
            </Button>
          </div>
        </div>
      </Card>
    );
  }

  render() {
    const { classes } = this.props;
    const { formOpen } = this.state;
    return (
      <div>
        <Button id="filter" onClick={this.onToggleForm}>
          <Icon
            className={classes.filterIcon}
            name={formOpen ? "close" : "filter_list"}
          />
          Filter
        </Button>
        {formOpen && this.renderForm()}
      </div>
    );
  }
}

export default withStyles(styles)(TableFilter);
